import {
  Box,
  TableCell,
  TableRow,
  Typography,
} from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import {
  FileCopy,
} from '@material-ui/icons';
import { formatDate } from '@roc/feature-utils';
import { Button, CopyText } from '@roc/ui';
import { observer } from 'mobx-react';
import { Fragment } from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  headerRow: {
    border: '1px solid #ccc',
    '& td': {
      padding: '8px',
    },
  },
  boldValues: {
    fontWeight: 'bold',
  },
}));

export const PointOfContactTableRow = observer(({ store, contact }) => {
  const classes = useStyles({});

  return (
    <Fragment key={contact.contactId}>
      <TableRow className={classes.headerRow}>
        <TableCell>
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent="space-between"
            px={0}
            py={1}
            ml={0}
          >
            <Typography
            >{`${contact?.firstName} ${contact.lastName}`}</Typography>
          </Box>
        </TableCell>
        <TableCell>
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent="space-between"
            px={0}
            py={1}
            ml={0}
          >
            <Typography>
              {contact?.email ?? '-'}
            </Typography>
          </Box>
        </TableCell>
        <TableCell>
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent="space-between"
            px={0}
            py={1}
            ml={0}
          >
            <Typography>
              {contact?.phone ?? '-'}
            </Typography>
          </Box>
        </TableCell>
        <TableCell>
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent="space-between"
            px={0}
            py={1}
            ml={0}
          >
            <Typography>
              {formatDate(contact?.createdDate) ?? '-'}
            </Typography>
          </Box>
        </TableCell>
      </TableRow>
    </Fragment>
  );
});
